import { useEffect, useState } from 'react'

import { Dropdown, Menu } from 'antd'
import { connect } from 'react-redux'
import { getTranslate } from 'react-localize-redux'

import { getUser } from '../../../../reducers/UserReducer'
import GenericStatesPellet from '../../StatesPellet/GenericStatesPellet'
import { selectInstitutionConstraintsByInstitution } from '../../../../Selectors/InstitutionConstraints/InstitutionConstraintsSelector'
import { buildMissingPropertiesMessage } from '../../InternshipsManager/utils/utils'
import { InternshipStates } from '../../../../utils/constants'

const { PENDING_STUDENT_DATA_MISSING } = InternshipStates

const mapStateToProps = state => {
  return {
    constraints: selectInstitutionConstraintsByInstitution(state),
    t: getTranslate(state.locale),
    user: getUser(state.getUser)
  }
}

const DropdownStatesSelector = ({ constraints, internship, showLabel, states, t, user, onChange }) => {
  const [missingConstraintsChunk, setMissingConstraintsChunk] = useState(null)

  useEffect(() => {
    if (internship.institution && internship.state === PENDING_STUDENT_DATA_MISSING) {
      setMissingConstraintsChunk(buildMissingPropertiesMessage(
        internship,
        constraints[internship.institution.id],
        t
      ))
    }
  }, [constraints, internship.institution, internship.state, t])

  const defaultStatePellet = (user, i) => (
    <GenericStatesPellet
      dimensions='square-15'
      context={user.context}
      state={i.state}
    />
  )

  const menu = (
    <Menu>
      {typeof states === 'object' && states.filter(s => internship.state !== s.state).map(s => {
        return (
          <Menu.Item key={s.state} onClick={() => onChange(s.state)}>
            <div className='internship-state-pellet-option open'>
              <GenericStatesPellet
                dimensions='square-15'
                context={user.context}
                state={s.state}
                missingConstraintsChunk={missingConstraintsChunk}
                showLabel={showLabel}
              />
            </div>
          </Menu.Item>
        )
      })}
    </Menu>
  )

  return (
    <Dropdown overlay={menu} placement='bottomCenter' trigger={['click']}>
      <span>{defaultStatePellet(user, internship)}</span>
    </Dropdown>
  )
}

export default connect(mapStateToProps)(DropdownStatesSelector)
